import { render } from "./UpdateBasicInfo.vue?vue&type=template&id=b50fa77c&scoped=true"
import script from "./UpdateBasicInfo.vue?vue&type=script&lang=js"
export * from "./UpdateBasicInfo.vue?vue&type=script&lang=js"

import "./UpdateBasicInfo.vue?vue&type=style&index=0&id=b50fa77c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b50fa77c"

export default script